import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-404864e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactContainer" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "title" }, "Interested?", -1))
const _hoisted_5 = {
  id: "form",
  ref: "form"
}
const _hoisted_6 = {
  ref: "user_name",
  placeholder: " name",
  type: "text",
  name: "user_name",
  id: "user_name"
}
const _hoisted_7 = {
  ref: "user_phone",
  placeholder: " phone number",
  type: "text",
  name: "phoneNumber",
  id: "user_phone"
}
const _hoisted_8 = {
  ref: "user_email",
  placeholder: " email",
  type: "text",
  name: "user_email",
  id: "user_email"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"selectWrapper\" data-v-404864e8><select id=\"updated\" name=\"updated\" data-v-404864e8><option value=\"yes\" data-v-404864e8>Yes</option><option value=\"no\" data-v-404864e8>No</option></select><label class=\"selectLabel\" for=\"updated\" data-v-404864e8>Stay updated about iCandy?</label></div>", 1)
const _hoisted_10 = { class: "messageWrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "messageLabel" }, "Any additonal information?", -1))
const _hoisted_12 = {
  ref: "message",
  placeholder: " message",
  type: "text",
  name: "message",
  id: "message"
}
const _hoisted_13 = { class: "submitContainer" }
const _hoisted_14 = {
  type: "button",
  ref: "submit",
  id: "submit",
  value: "Submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("input", _hoisted_6, null, 512),
          _createElementVNode("input", _hoisted_7, null, 512),
          _createElementVNode("input", _hoisted_8, null, 512),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("textarea", _hoisted_12, null, 512)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("input", _hoisted_14, null, 512)
          ])
        ], 512)
      ])
    ])
  ]))
}